/**
 * Buyer analytics event taxonomy (Milestone 28).
 * Naming: lowercase_snake_case, action-oriented.
 */
export {
  BUYER_ANALYTICS_EVENTS,
  BUYER_EVENT_CATEGORIES,
} from "./automapAnalyticsEvents";

export {
  EVENT_CATEGORY_MAP,
  resolveEventCategory,
} from "./buyerEventCategoryMap";

export const ANALYTICS_DATE_RANGES = [
  { value: "today", label: "Hoy" },
  { value: "last_7_days", label: "Últimos 7 días" },
  { value: "last_30_days", label: "Últimos 30 días" },
  { value: "this_month", label: "Este mes" },
];

const SENSITIVE_KEYS = new Set([
  "phone",
  "whatsapp",
  "buyerWhatsapp",
  "buyerEmail",
  "buyerName",
  "email",
  "contact",
  "firstName",
  "lastName",
  "message",
  "messageToDealer",
]);

/** @deprecated import sanitizeAnalyticsPayload from analytics/sanitize or analytics/index */
export function sanitizeAnalyticsPayloadLegacy(payload = {}) {
  const clean = {};
  for (const [key, value] of Object.entries(payload)) {
    if (SENSITIVE_KEYS.has(key)) continue;
    if (typeof value === "string" && /^\d{10,}$/.test(value.replace(/\D/g, ""))) continue;
    clean[key] = value;
  }
  return clean;
}
